export default __webpack_public_path__ + "static/line-presentation_kz-4cb8a172cd3e1a11ba432db9d0b7e818.png";